import { createApiSlice } from "@common";
import { CRUD_COMPETITOR_TYPE } from "@routes";

const apiConfig = [
  {
    name: "addCompetitorType",
    method: "post",
    url: CRUD_COMPETITOR_TYPE,
    stateKey: "message",
  },
  {
    name: "getCompetitorType",
    method: "get",
    url: CRUD_COMPETITOR_TYPE,
    stateKey: "data",
  },
  {
    name: "updateCompetitorType",
    method: "put",
    url: CRUD_COMPETITOR_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteCompetitorType",
    method: "delete",
    url: CRUD_COMPETITOR_TYPE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"competitorType",
 apiConfig, 
 customReducers);
const competitorTypeSlice = slice;

export default competitorTypeSlice.reducer;

export const {
  addCompetitorType,
  getCompetitorType,
  updateCompetitorType,
  deleteCompetitorType,
} = thunks;

export const { rowSelect } = actions;
